ace.define("ace/mode/training_phrases_highlight_rules", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text_highlight_rules"], function (acequire, exports, module) {
  "use strict";

  var oop = acequire("../lib/oop");
  var TextHighlightRules = acequire("./text_highlight_rules").TextHighlightRules;

  var TrainingPhrasesHighlightRules = function () {
    //var keywordMapper;
    this.variablePosition = [];
  
    this.setVariablePossitionArray = function (arr) {
      if(arr){
        this.variablePosition = arr;
      }
      else {
        this.variablePosition = [];
      }
    }
    
    var getTagCssClass = function (s, variablePosition) {
        var h = variablePosition.indexOf(s.slice(1,-1));
        return "variable-color-" + h;
    }


    this.setKeywordsSearchToken = function (kwMap) {
      this.searchTokenRule.onMatch = this.createKeywordMapper(kwMap, "searchToken");
    }


    this.searchTokenRule = {
      regex: "\\w+\\b",
      onMatch: function () { return "text" }
    }

    this.$rules = {
      "start": [
        {
          token: function (a) {
            return "variable" + " " + getTagCssClass(a, this.variablePosition);
          }.bind(this),
          regex: /`[^`]+`/
        },
        {
          token: "text",
          regex: "\\+"
        },
/*         {
          token: keywordMapper,
          regex: "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
        }, */
        this.searchTokenRule
      ]

    };
    //this.normalizeRules();
  };

  oop.inherits(TrainingPhrasesHighlightRules, TextHighlightRules);

  exports.TrainingPhrasesHighlightRules = TrainingPhrasesHighlightRules;
});

ace.define("ace/mode/traningPhrases", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text", "ace/mode/training_phrases_highlight_rules"], function (acequire, exports, module) {
  "use strict";

  var oop = acequire("../lib/oop");
  var TextMode = acequire("./text").Mode;
  var TrainingPhrasesHighlightRules = acequire("./training_phrases_highlight_rules").TrainingPhrasesHighlightRules;

  var Mode = function () {
    this.HighlightRules = TrainingPhrasesHighlightRules;
    this.$behaviour = this.$defaultBehaviour;
  };
  oop.inherits(Mode, TextMode);

  (function () {

    this.lineCommentStart = "--";

    this.$id = "ace/mode/traningPhrases";
  }).call(Mode.prototype);

  exports.Mode = Mode;

});



/* ***** BEGIN LICENSE BLOCK *****
 * Distributed under the BSD license:
 *
 * Copyright (c) 2010, Ajax.org B.V.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *     * Redistributions of source code must retain the above copyright
 *       notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above copyright
 *       notice, this list of conditions and the following disclaimer in the
 *       documentation and/or other materials provided with the distribution.
 *     * Neither the name of Ajax.org B.V. nor the
 *       names of its contributors may be used to endorse or promote products
 *       derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * ***** END LICENSE BLOCK ***** */

ace.define("ace/mode/traningPhrasesTooltip", ["require", "exports", "module"], function (acequire, exports, module) {
  "use strict";

  var dom = acequire("../lib/dom");
  var oop = acequire("../lib/oop");
  var event = acequire("../lib/event");
  var Range = acequire("../range").Range;
  var Tooltip = acequire("../tooltip").Tooltip;

  var TokenTooltip = function (editor) {
    if (editor.tokenTooltip)
      return;
    Tooltip.call(this, editor.container);
    editor.tokenTooltip = this;
    this.editor = editor;

    this.update = this.update.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    event.addListener(editor.renderer.scroller, "mousemove", this.onMouseMove);
    event.addListener(editor.renderer.content, "mouseout", this.onMouseOut);
  }

  oop.inherits(TokenTooltip, Tooltip);

  (function () {
    this.token = {};
    this.range = new Range();

    this.update = function () {
      this.$timer = null;

      var r = this.editor.renderer;
      if (this.lastT - (r.timeStamp || 0) > 1000) {
        r.rect = null;
        r.timeStamp = this.lastT;
        this.maxHeight = window.innerHeight;
        this.maxWidth = window.innerWidth;
      }

      var canvasPos = r.rect || (r.rect = r.scroller.getBoundingClientRect());
      var offset = (this.x + r.scrollLeft - canvasPos.left - r.$padding) / r.characterWidth;
      var row = Math.floor((this.y + r.scrollTop - canvasPos.top) / r.lineHeight);
      var col = Math.round(offset);

      var screenPos = { row: row, column: col, side: offset - col > 0 ? 1 : -1 };
      var session = this.editor.session;
      var docPos = session.screenToDocumentPosition(screenPos.row, screenPos.column);
      var token = session.getTokenAt(docPos.row, docPos.column);

      if (!token && !session.getLine(docPos.row)) {
        token = {
          type: "",
          value: "",
          state: session.bgTokenizer.getState(0)
        };
      }
      if (!token) {
        session.removeMarker(this.marker);
        this.hide();
        return;
      }


      if (token.type !== "variable") {
        session.removeMarker(this.marker);
        this.hide();
        return;
      }

      var tokenText = token.type;


      if (token.state)
        tokenText += "|" + token.state;
      if (token.merge)
        tokenText += "\n  merge";
      if (token.stateTransitions)
        tokenText += "\n  " + token.stateTransitions.join("\n  ");

      if (this.tokenText != tokenText) {
        this.setText(tokenText);
        this.width = this.getWidth();
        this.height = this.getHeight();
        this.tokenText = tokenText;
      }

      this.show(null, this.x, this.y);

      this.token = token;
      session.removeMarker(this.marker);
      this.range = new Range(docPos.row, token.start, docPos.row, token.start + token.value.length);
      this.marker = session.addMarker(this.range, "ace_bracket", "text");
    };

    this.onMouseMove = function (e) {
      this.x = e.clientX;
      this.y = e.clientY;
      if (this.isOpen) {
        this.lastT = e.timeStamp;
        this.setPosition(this.x, this.y);
      }
      if (!this.$timer)
        this.$timer = setTimeout(this.update, 100);
    };

    this.onMouseOut = function (e) {
      if (e && e.currentTarget.contains(e.relatedTarget))
        return;
      this.hide();
      this.editor.session.removeMarker(this.marker);
      this.$timer = clearTimeout(this.$timer);
    };

    this.setPosition = function (x, y) {
      if (x + 10 + this.width > this.maxWidth)
        x = window.innerWidth - this.width - 10;
      if (y > window.innerHeight * 0.75 || y + 20 + this.height > this.maxHeight)
        y = y - this.height - 30;

      Tooltip.prototype.setPosition.call(this, x + 10, y + 20);
    };

    this.destroy = function () {
      this.onMouseOut();
      event.removeListener(this.editor.renderer.scroller, "mousemove", this.onMouseMove);
      event.removeListener(this.editor.renderer.content, "mouseout", this.onMouseOut);
      delete this.editor.tokenTooltip;
    };

  }).call(TokenTooltip.prototype);

  exports.TokenTooltip = TokenTooltip;

});